<template>
  <v-app id="app" class="bg-black">
    <router-view/>
  </v-app>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      drawer: false
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
